const cue1 = [
    "Se vencer o jogo é o que anseias",
    "Os dez desafios terás que enfrentar",
    "Para a tua jornada começar",
    "OK terás que digitar",
    "ok"
]



const cue2 = [
  "Guardiãs que pelo sossego ficam a zelar",
  "Em um corredor com três portas",
  "Material e equipamento desportivo tem numa delas",
  "Para lá entrar, às guardiãs deverás falar",
  "13XI14HR"
]

const cue3 = [
  "O primeiro passo são poucos os que dão",
  "O segundo já muitos desistirão",
  "O terceiro tens uma condição:",
  "Da máquina verificar o nome repetido no cupão",
  "sielaff"
]

const cue4 = [
  "Para este projeto viver",
  "Existe uma única peça que o faz mover",
  "De mim vem uma imensão gratidão",
  "A essa peça que deste projeto fá-lo a continuação",
  "playername"
]

const cue5 = [
  "Neste grande espaço escolar",
  "Onde imensas divisões existem",
  "Em uma está a guardar",
  "O conhecimento que muitos hesitem",
  "21BE32CH"
]

const cue6 = [
  "Uma sala com itens diversos",
  "Desde tintas a uma folha",
  "Faz corretamente a tua escolha",
  "Para assim enfrentares os próximos versos",
  "10PL07CE"
]

const cue7 = [
  "Onde a energia é reabastecida",
  "e o interesse satisfeito",
  "Solicita a senha 108",
  "E a chave desta adivinha será cumprida",
  "10SH80BR"
]

const cue8 = [
  "Agora também uma entrada",
  "a qual era somente uma saída.",
  "Lá não tem muito, pouco mais que nada",
  "O suficiente para saber a tua chegada e partida",
  "24EN07SD"
]

const cue9 = [
  "Imersos na água",
  "Onde um barco se localiza.",
  "Não vêem a lua",
  "E são dez que se totaliza",
  "52PX10AQ"
]

const cue10 = [
  "São várias maquinarias, monumentos",
  "Cada uma com códigos inscritos",
  "Une-os como fragmentos",
  "Que a resposta engloba nesses efeitos",
  "Thankyou"
]

//Test Zone

// const cue1 = [
//   "1",
//   "1",
//   "1",
//   "1",
//   "1"
// ]



// const cue2 = [
// "2",
// "2",
// "2",
// "2",
// "2"
// ]

// const cue3 = [
//   "3",
//   "3",
//   "3",
//   "3",
//   "3"
// ]

// const cue4 = [
//   "4",
//   "4",
//   "4",
//   "4",
//   "4"
// ]

// const cue5 = [
//   "5",
//   "5",
//   "5",
//   "5",
//   "5"
// ]

// const cue6 = [
//   "6",
//   "6",
//   "6",
//   "6",
//   "6"
// ]

// const cue7 = [
//   "7",
//   "7",
//   "7",
//   "7",
//   "7"
// ]

// const cue8 = [
//   "8",
//   "8",
//   "8",
//   "8",
//   "8"
// ]

// const cue9 = [
//   "9",
//   "9",
//   "9",
//   "9",
//   "9"
// ]

// const cue10 = [
//   "10",
//   "10",
//   "10",
//   "10",
//   "10"
// ]

export const cues = [
    cue1,
    cue2,
    cue3,
    cue4,
    cue5,
    cue6,
    cue7,
    cue8,
    cue9,
    cue10
] 